<template>
	<div class="parserChildrenDetail">
		<el-button type="primary" plain class="backClass" @click="backClick()">返回</el-button>
		<div class="tableBox">
			<el-table :data="rowList" style="width: 100%">
				<el-table-column prop="name" label="抄读子集" min-width="1%">
				</el-table-column>
				<el-table-column prop="code" label="数据标识" min-width="1%">
				</el-table-column>
				<el-table-column prop="total" label="包含数据项" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="是否事件" min-width="1%">
					<template slot-scope="scope">{{scope.row.isevent|iseventFilter}}</template>
				</el-table-column>
				<el-table-column prop="address" label="" min-width="2%">
				</el-table-column>
			</el-table>
		</div>
		<div class="headerBox">
			抄读项列表
			<el-button type="primary" plain class="addButtonClass" @click="addClick()" v-if="lock_status==0">编辑抄读项</el-button>
		</div>
		<div class="headerBox">
			<span style="margin-right: 40px;color: #999;">数据标识</span>
			<span v-if="rowList[0]">
				 {{rowList[0].code}}
			</span>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" :row-class-name="getRowClass" v-loading="loading">
				<el-table-column label="序 号" width="70">
					<template slot-scope="scope"><span style="padding-left: 6px;">{{(pageIndex-1)*pageSize+scope.$index+1}}</span></template>
				</el-table-column>
				<el-table-column prop="" label="" min-width="1%" type="expand">
					<template slot-scope="scope">
						<div class="childTable2">
							<!--子表格-->
							<el-table :data="scope.row.childs" style="width: 100%" v-show="scope.row.childs.length>0" :row-class-name="getRowClass">
								<el-table-column prop="" label="" min-width="6%"></el-table-column>
								<el-table-column prop="" label="" min-width="4%" type="expand">
									<template slot-scope="scope">
										<div class="childTable2">
											<!--子子表格-->
											<el-table :data="scope.row.childs" style="width: 100%" v-show="scope.row.childs.length>0">
												<el-table-column prop="" label="" min-width="7%"></el-table-column>
												<el-table-column prop="" label="值" min-width="1%">
													<template slot-scope="scope">{{scope.row.enum_val}}</template>
												</el-table-column>
												<el-table-column prop="" label="对应含义" min-width="1%">
													<template slot-scope="scope">{{scope.row.enum_name}}</template>
												</el-table-column>
												<el-table-column prop="" label="" min-width="2%"></el-table-column>
												<el-table-column prop="" label="事件" min-width="1%" v-if="scope.row.child_isevent==1">
													<template slot-scope="scope">{{scope.row.enum_isevent|sort_typeFilter}}</template>
												</el-table-column>
												<el-table-column prop="" label="详情OAD" min-width="1%" v-if="scope.row.child_isevent==1">
													<template slot-scope="scope">{{scope.row.enum_oad}}</template>
												</el-table-column>
											</el-table>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="" label="配置类型" min-width="9%">
									<template slot-scope="scope">{{scope.row.child_type|typeFilter}}</template>
								</el-table-column>
								<el-table-column prop="" label="抄读项" min-width="9%">
									<template slot-scope="scope">{{scope.row.child_title_name}}</template>
								</el-table-column>
								<el-table-column prop="" label="起始字节" min-width="9%">
									<template slot-scope="scope">{{scope.row.child_start}}</template>
								</el-table-column>
								<el-table-column prop="" label="结束字节" min-width="9%">
									<template slot-scope="scope">{{scope.row.child_end}}</template>
								</el-table-column>
								<el-table-column prop="" label="是否倒数" min-width="9%">
									<template slot-scope="scope">{{scope.row.child_sort|sort_typeFilter}}</template>
								</el-table-column>
								<el-table-column prop="" label="数据类型" min-width="9%">
									<template slot-scope="scope">{{scope.row.child_data_type}}</template>
								</el-table-column>
								<el-table-column prop="" label="是否有值含义" min-width="9%">
									<template slot-scope="scope">{{scope.row.child_isenum|isenumFilter}}</template>
								</el-table-column>
								<el-table-column prop="" label="单位" min-width="9%">
									<template slot-scope="scope">{{scope.row.child_unit}}</template>
								</el-table-column>
								<el-table-column prop="" label="数据精度" min-width="9%">
									<template slot-scope="scope">{{scope.row.child_precision}}</template>
								</el-table-column>
								<el-table-column prop="" label="是否事件" min-width="9%">
									<template slot-scope="scope">{{scope.row.child_isevent|sort_typeFilter}}</template>
								</el-table-column>
								<el-table-column prop="" label="变比" min-width="9%">
									<template slot-scope="scope">{{scope.row.child_isv|isvFilter}}
										<span v-if="scope.row.isv==1&&scope.row.isa==1">、</span> {{scope.row.child_isa|isaFilter}}
									</template>
								</el-table-column>
							</el-table>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="" label="配置类型" min-width="1%">
					<template slot-scope="scope">{{scope.row.type|typeFilter}}</template>
				</el-table-column>
				<el-table-column prop="title_name" label="抄读项" min-width="1%">
				</el-table-column>
				<el-table-column prop="start_idx" label="起始字节" min-width="1%">
				</el-table-column>
				<el-table-column prop="end_idx" label="结束字节" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="是否倒数" min-width="1%">
					<template slot-scope="scope">{{scope.row.sort_type|sort_typeFilter}}</template>
				</el-table-column>
				<el-table-column prop="data_type" label="数据类型" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="是否有值含义" min-width="1%">
					<template slot-scope="scope">{{scope.row.isenum|isenumFilter}}</template>
				</el-table-column>
				<el-table-column prop="unit_name" label="单位" min-width="1%">
				</el-table-column>
				<el-table-column prop="precision_str" label="数据精度" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="是否事件" min-width="1%">
					<template slot-scope="scope">{{scope.row.isevent|sort_typeFilter}}</template>
				</el-table-column>
				<el-table-column prop="" label="变比" min-width="1%">
					<template slot-scope="scope">{{scope.row.isv|isvFilter}}
						<span v-if="scope.row.isv==1&&scope.row.isa==1">、</span> {{scope.row.isa|isaFilter}}
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagination">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="total>20">
			</el-pagination>
		</div>
		<!--弹窗-->
		<div class='popContainer' v-if="show" :style="{'padding': paddingV+'%' }">
			<div class="headerTop">
				<span style="margin-left: 20px;">编辑抄读项</span>
				<div class="buttomBox">
					<el-button @click="save()" class="confrim" type="primary">确定</el-button>
					<el-button @click="cancleClick()" class="cancle">取消</el-button>
				</div>
			</div>
			<div class="headerTop">
				<span style="margin-left: 20px;">数据标识</span>
				<input type="text" class="inputClass" v-model="codeValue" @change="codeValueChange()" />
				<span style="margin-left: 20px;">抄读子集</span>
				<input type="text" class="inputClass" v-model="childValue" />
				<div class="rightBox">
					<span style="margin-left: 20px;" class="numText">数据项数量</span>
					<input type="text" class="inputClass2" v-model="codeNum" :disabled="inputDisabled" />
					<el-button type="primary" plain class="clickButtonClass" @click="createClick()" :disabled="inputDisabled">生成</el-button>
				</div>
			</div>
			<div class="content">
				<!--父表格-->
				<!--<el-table :data="tableData" style="width: 100%" :row-class-name="getRowClass" ref="tableRef" @expand-change="expandSelect" type='index' :row-key='getRowKeys' :expand-row-keys="expands" >-->
				<el-table :data="tableData" style="width: 100%" :row-class-name="getRowClass" ref="tableRef">
					<el-table-column prop="" label="" min-width="3%" type="expand">
						<template slot-scope="scope">
							<div class="childTable" @click="expandChange(scope.$index)" @mouseover="mouseOver(scope.$index)">
								<!--子表格-->
								<el-table :data="scope.row.childs" style="width: 100%" v-show="scope.row.type==1" :row-class-name="getRowClass" ref="tableRef3" @expand-change="expandSelect" type='index' :row-key='getRowKeys' :expand-row-keys="expands">
									<el-table-column prop="" label="" min-width="3%"></el-table-column>
									<el-table-column prop="" label="" min-width="3%" type="expand">
										<template slot-scope="scope">
											<div class="childTable" @click="expandChange(scope.$index)">
												<!--子子表格-->
												<el-table :data="scope.row.childs" style="width: 100%">
													<el-table-column prop="" label="" min-width="7%"></el-table-column>
													<el-table-column prop="" label="值" min-width="2%">
														<template slot-scope="scope">
															<el-input v-model="scope.row.enum_val" type="number"></el-input>
														</template>
													</el-table-column>
													<el-table-column prop="" label="对应含义" min-width="4%">
														<template slot-scope="scope">
															<el-input v-model="scope.row.enum_name"></el-input>
														</template>
													</el-table-column>
													<el-table-column prop="" label="" min-width="2%" v-if="scope.row.child_isevent">
														<template slot-scope="scope">
															<div class="checkBoxClass">
																<el-checkbox v-model="scope.row.enum_isevent">事件</el-checkbox>
															</div>
														</template>
													</el-table-column>
													<el-table-column prop="" label="" min-width="15%" v-else>
													</el-table-column>
													<el-table-column prop="" label="详情OAD" min-width="13%" v-if="scope.row.child_isevent">
														<template slot-scope="scope">
															<el-input v-model="scope.row.enum_oad" @input="scope.row.enum_oad = scope.row.enum_oad.replace(/[\u4e00-\u9fa5d]/g, '');"></el-input>
														</template>
													</el-table-column>
												</el-table>
											</div>
										</template>
									</el-table-column>
									<!--TODO-->
									<!--子①第一级-->
									<!--<el-table-column prop="" label="一级分类" min-width="3%">
										<template slot-scope="scope">
											<a-select show-search v-model="scope.row.child_code" show-search option-filter-prop="children" style="width: 100%" :filter-option="filterOption" dropdownClassName="select-drop-down-platform">
												<a-select-option v-for="(item,index) in titleData" :key="index" :label="item.title" :value="item.id">
													{{item.title}}
												</a-select-option>
											</a-select>
										</template>
									</el-table-column>
									<el-table-column prop="" label="二级分类" min-width="3%">
										<template slot-scope="scope">
											<a-select show-search v-model="scope.row.child_code" show-search option-filter-prop="children" style="width: 100%" :filter-option="filterOption" dropdownClassName="select-drop-down-platform">
												<a-select-option v-for="(item,index) in titleData" :key="index" :label="item.title" :value="item.id">
													{{item.title}}
												</a-select-option>
											</a-select>
										</template>
									</el-table-column>-->
									<!--<el-table-column prop="" label="抄读项" min-width="4%">
										<template slot-scope="scope">
											<select v-model="scope.row.child_code" placeholder="请选择" style="width:100%">
												<option v-for="item in titleData" :key="item.id" :label="item.title" :value="item.id">
												</option>
											</select>
										</template>
									</el-table-column>-->
									<!--子抄读项-->
									<el-table-column prop="" label="抄读项" min-width="4%">
										<template slot-scope="scope">
											<el-select v-model="scope.row.child_code" class="select-unitName select-option-father" popper-class="select_report_and_type" :popper-append-to-body="false" ref="elSelectTable">
												<el-option :value="baseTableList">
													<el-tree class="unit-tree" node-key="label" :props="defaultProps" :default-expanded-keys="unitTreeExpandedId" ref="tableDom" highlight-current :expand-on-click-node='false' @node-click="clickUnitTreeNodeChild" lazy :load="load" @current-change="rowClick(scope.$index)">
													</el-tree>
												</el-option>
											</el-select>
										</template>
									</el-table-column>
									<!--子开始字节-->
									<el-table-column prop="" label="起始字节" min-width="2%">
										<template slot-scope="scope">
											<el-input v-model="scope.row.child_start" @change="start_idxChange(scope.row.child_isenum,scope.$index,scope.row)"></el-input>
										</template>
									</el-table-column>
									<!--子结束字节-->
									<el-table-column prop="" label="结束字节" min-width="2%">
										<template slot-scope="scope">
											<el-input v-model="scope.row.child_end" @change="start_idxChange(scope.row.child_isenum,scope.$index,scope.row)"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="" label="" min-width="2%"></el-table-column>
									<el-table-column prop="" label="是否有值含义" min-width="5%">
										<template slot-scope="scope">
											<!--子②表格===-->
											<el-radio v-model="scope.row.child_isenum" label="1" @change="radioChange(scope.row.child_isenum,scope.$index,scope.row)">是</el-radio>
											<el-radio v-model="scope.row.child_isenum" label="0" @change="radioChange(scope.row.child_isenum,scope.$index,scope.row)">否</el-radio>
										</template>
									</el-table-column>
									<!--子单位-->
									<el-table-column prop="" label="单位" min-width="2%">
										<template slot-scope="scope">
											<el-input v-model="scope.row.child_unit" v-if="scope.row.child_isenum=='0'"></el-input>
										</template>
									</el-table-column>
									<!--子精度-->
									<el-table-column prop="" label="数据精度" min-width="3%">
										<template slot-scope="scope">
											<el-input v-model="scope.row.child_precision" type="number" max="9" min="0" v-if="scope.row.child_isenum=='0'"></el-input>
										</template>
									</el-table-column>
									<!--子变比-->
									<el-table-column prop="" label="" min-width="2%">
										<template slot-scope="scope">
											<div class="checkBoxClass">
												<el-checkbox v-model="scope.row.child_isevent">事件</el-checkbox>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="" label="变比" min-width="4%">
										<template slot-scope="scope">
											<div class="checkBoxClass" v-if="scope.row.child_isenum=='0'">
												<el-checkbox v-model="scope.row.child_isa">电流</el-checkbox>
											</div>
											<div class="checkBoxClass" v-if="scope.row.child_isenum=='0'">
												<el-checkbox v-model="scope.row.child_isv">电压</el-checkbox>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="" label="操作" min-width="2%">
										<template slot-scope="scope">
											<a class="editClass" @click="deleteClickS(scope.$index)">删除</a>
										</template>
									</el-table-column>
								</el-table>
								<el-button type="primary" icon="el-icon-plus" circle class="addButtonClassF" @click.stop="addCreate2(scope.$index)" v-if="scope.row.type==1"></el-button>
							</div>
						</template>
					</el-table-column>
					<!--父表格内容------------------------------------------------------------------------------>
					<el-table-column prop="" label="配置类型" min-width="3%">
						<template slot-scope="scope">
							<select v-model="scope.row.type" placeholder="请选择" style="width:100%">
								<option v-for="item in configurationTypeList" :key="item.id" :label="item.name" :value="item.id">
								</option>
							</select>
						</template>
					</el-table-column>
					<!--TODO-->
					<!--<el-table-column prop="" label="一级分类" min-width="3%">
						<template slot-scope="scope">
							<a-select show-search v-model="scope.row.title_code" show-search option-filter-prop="children" style="width: 100%" :filter-option="filterOption" v-show="scope.row.type==0" @change="specilChange(scope.row.title_code,scope.$index)" dropdownClassName="select-drop-down-platform">
								<a-select-option v-for="(item,index) in titleData" :key="index" :label="item.title" :value="item.id">
									{{item.title}}
								</a-select-option>
							</a-select>
						</template>
					</el-table-column>
					<el-table-column prop="" label="二级分类" min-width="3%">
						<template slot-scope="scope">
							<a-select show-search v-model="scope.row.title_code" show-search option-filter-prop="children" style="width: 100%" :filter-option="filterOption" v-show="scope.row.type==0" @change="specilChange(scope.row.title_code,scope.$index)" dropdownClassName="select-drop-down-platform">
								<a-select-option v-for="(item,index) in titleData" :key="index" :label="item.title" :value="item.id">
									{{item.title}}
								</a-select-option>
							</a-select>
						</template>
					</el-table-column>-->
					<!--<el-table-column prop="" label="抄读项" min-width="4%">
						<template slot-scope="scope">
							<select v-model="scope.row.title_code" placeholder="请选择" style="width:100%" v-show="scope.row.type==0" @change="specilChange(scope.row.title_code,scope.$index)">
								<option v-for="item in titleData" :key="item.id" :label="item.title" :value="item.id">
								</option>
							</select>
						</template>
					</el-table-column>-->
					<el-table-column prop="" label="抄读项" min-width="4%">
						<template slot-scope="scope">
							<el-select v-model="scope.row.title_code" class="select-unitName select-option-father" popper-class="select_report_and_type" :popper-append-to-body="false" ref="elSelectTable" v-show="scope.row.type==0">
								<el-option :value="baseTableList">
									<el-tree class="unit-tree" node-key="label" :props="defaultProps" :default-expanded-keys="unitTreeExpandedId" ref="tableDom" highlight-current :expand-on-click-node='false' @node-click="clickUnitTreeNode" lazy :load="load" @current-change="rowClick(scope.$index)">
									</el-tree>
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column prop="" label="起始字节" min-width="2%">
						<template slot-scope="scope">
							<el-input v-model="scope.row.start_idx"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="" label="结束字节" min-width="2%">
						<template slot-scope="scope">
							<el-input v-model="scope.row.end_idx"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="" label="" min-width="2%">
						<template slot-scope="scope">
							<div class="checkBoxClass" v-if="scope.row.type==0">
								<el-checkbox v-model="scope.row.sort_type" v-show="scope.row.type==0">倒序</el-checkbox>
							</div>
							<span class="numText" v-if="scope.row.type==1">子项数量</span>
						</template>
					</el-table-column>
					<el-table-column prop="" label="数据类型" min-width="5%">
						<template slot-scope="scope">
							<select v-model="scope.row.data_type" placeholder="请选择" style="width:100%" v-show="scope.row.type==0">
								<option v-for="item in dataTypeList" :key="item" :label="item" :value="item">
								</option>
							</select>
							<div v-if="scope.row.type==1">
								<input type="text" class="inputClass3" v-model="scope.row.codeNum2" :disabled="scope.row.buttonDisabled" />
								<el-button type="primary" plain class="clickButtonClass2" @click="createClick2(scope.$index,scope.row.codeNum2,scope.row)" :disabled="scope.row.buttonDisabled">生成</el-button>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="单位" min-width="2%">
						<template slot-scope="scope">
							<el-input v-model="scope.row.unit_name" v-show="scope.row.type==0"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="" label="数据精度" min-width="3%">
						<template slot-scope="scope">
							<el-input v-model="scope.row.precision_str" v-show="scope.row.type==0" type="number" max="9" min="0"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="" label="" min-width="2%">
						<template slot-scope="scope">
							<div class="checkBoxClass" v-if="scope.row.type==0">
								<el-checkbox v-model="scope.row.isevent" v-show="scope.row.type==0">事件</el-checkbox>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="变比" min-width="4%">
						<template slot-scope="scope">
							<div class="checkBoxClass" v-if="scope.row.type==0">
								<el-checkbox v-model="scope.row.isa" v-show="scope.row.type==0">电流</el-checkbox>
							</div>
							<div class="checkBoxClass" v-if="scope.row.type==0">
								<el-checkbox v-model="scope.row.isv" v-show="scope.row.type==0">电压</el-checkbox>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="操作" min-width="2%">
						<template slot-scope="scope">
							<a class="editClass" @click.prevent="deleteClickQ(scope.$index,scope.row.id)">删除</a>
						</template>
					</el-table-column>
				</el-table>
				<el-button type="primary" icon="el-icon-plus" circle class="addButtonClassF" @click="addCreate()"></el-button>
				<!--<div class="pagination">
					<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="total>20">
					</el-pagination>
				</div>-->
			</div>

		</div>

	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import dataList from '../../../static/js/dataList.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			this.firstPageIndex = this.$route.query.fI
			this.secondPageIndex = this.$route.query.sI
			this.dataTypeList = dataList.dataTypeList;
			this.parser_item_id = this.$route.query.id
			this.parser_id = this.$route.query.pid
			this.lock_status = this.$route.query.ls
			this.titleList(); //数据项列表
			this.getParser_item();
		},
		filters: {
			isenumFilter: function(val) {
				if(val == "0") {
					return "无";
				}
				if(val == "1") {
					return "有";
				}
			},
			iseventFilter: function(val) {
				if(val == "0") {
					return "no";
				}
				if(val == "1") {
					return "yes";
				}
			},
			typeFilter: function(val) {
				if(val == "0") {
					return "常规";
				}
				if(val == "1") {
					return "位解析";
				}
			},
			sort_typeFilter: function(val) {
				if(val == "0") {
					return "N";
				}
				if(val == "1") {
					return "Y";
				}
			},
			isvFilter: function(val) {
				if(val == "0") {
					return "";
				}
				if(val == "1") {
					return "电压";
				}
			},
			isaFilter: function(val) {
				if(val == "0") {
					return "";
				}
				if(val == "1") {
					return "电流";
				}
			},
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				loading: false, //加载状态
				pageSize: 20, //每页条数
				firstPageIndex: '', //第一个页面的当前页
				secondPageIndex: '', //第二个页面的当前页
				pageIndex: 1, //当前页
				total: 0, //总条数
				tableData: [],
				/*表单*/
				show: false, //遮罩层
				paddingV: '0.5',
				parser_item_id: '', //id
				rowList: [], //id列表
				titleData: [], //数据项
				configurationTypeList: [{
						id: 0,
						name: '常规'
					},
					{
						id: 1,
						name: '位解析'
					},
				], //配置类型
				dataTypeList: [], //数据类型
				codeNum: '', //第一层数据项数量
				codeValue: '', //数据标识
				codeValue2: '',
				childValue: '', //抄读子集
				inputDisabled: true, //禁用
				parentIndex: '', //第一层id
				childrenId: '', //第一层id
				parser_itemId: '', //parser_item的id
				expands: [],
				totalCode: 0,
				lock_status: '', //锁定状态
				parser_id: '',
				//select
				baseTableList: [],
				unitTreeExpandedId: [],
				baseTableName: '',
				defaultProps: {
					children: 'children',
					label: 'title',
					isLeaf: (data, node) => {
						if(node.level === 3) {
							return true
						}
					}
				},
				row_index: '', //第一级/第二级父级索引
				parent_index: '' //第一级索引
			}
		},
		methods: {
			filterOption(input, option) {
				return(
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			getRowKeys(row, val) {
				return row.sign
			},
			expandSelect(row, expandedRows) {
				var that = this
				if(expandedRows.length) {
					that.expands = []
					if(row) {
						that.expands.push(row.sign)
					}
				} else {
					that.expands = []
				}
			},
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getList();
			},
			//获取Parser_item列表
			getParser_item() {
				var params = {}
				let config = headers.headers(this.parser_item_id)
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser_item/' + this.parser_item_id, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.rowList = []
						this.rowList.push(res.data)
						this.codeValue = res.data.code
						this.codeValue2 = res.data.code
						this.childValue = res.data.name
					} else {
						this.rowList = []
						this.codeValue = ''
						this.nameValue = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//数据项列表
			titleList() {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/title/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.titleData = res.data
						this.getList();
					} else {
						this.titleData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//总条数
			getTotal() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					parser_item_id: this.parser_item_id,
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser_detail/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total = res.data
					} else {
						this.total = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取列表
			getList() {
				this.loading = true;
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					parser_item_id: this.parser_item_id,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser_detail/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading = false;
					this.getTotal();
					if(res.data.length > 0) {
						res.data.forEach(item => {
							item.sign = this.$uuid.v1()
							if(item.childs.length > 0) {
								item.buttonDisabled = true
							}
							item.codeNum2 = item.childs.length
							if(item.sort_type == 0) {
								item.sort_type = false
							} else if(item.sort_type == 1) {
								item.sort_type = true
							}
							if(item.isevent == 0) {
								item.isevent = false
							} else if(item.isevent == 1) {
								item.isevent = true
							}
							if(item.isa == 0) {
								item.isa = false
							} else if(item.isa == 1) {
								item.isa = true
							}
							if(item.isv == 0) {
								item.isv = false
							} else if(item.isv == 1) {
								item.isv = true
							}
							if(item.type == 1) {
								item.title_name = ''
							}
							item.title_code = Number(item.title_code)
							item.childs.forEach((item_z, i_z) => {
								item_z.sign = this.$uuid.v1()
								if(item_z.child_isevent == 0) {
									item_z.child_isevent = false
								} else if(item_z.child_isevent == 1) {
									item_z.child_isevent = true
								}
								if(item_z.child_isv == 0) {
									item_z.child_isv = false
								} else if(item_z.child_isv == 1) {
									item_z.child_isv = true
								}
								if(item_z.child_isa == 0) {
									item_z.child_isa = false
								} else if(item_z.child_isa == 1) {
									item_z.child_isa = true
								}
								if(item_z.child_isenum == 0) {
									item_z.child_isenum = '0'
								} else if(item_z.child_isenum == 1) {
									item_z.child_isenum = '1'
								}
								item_z.childs.forEach((item_t, i_t) => {
									if(item_t.enum_isevent == 0) {
										item_t.enum_isevent = false
									} else if(item_t.enum_isevent == 1) {
										item_t.enum_isevent = true
									}
								})
								item_z.child_code = Number(item_z.child_code)
							})
						})
						this.tableData = res.data
						this.tableData.forEach((item, index) => {
							item.index == index
							this.titleData.forEach(items => {
								if(item.title_code == items.id) {
									item.title_code = items.title
								}
								item.childs.forEach(itemc => {
									if(itemc.child_code == items.id) {
										itemc.child_code = items.title
									}
								})
							})
						})
						this.codeNum = this.tableData.length
						this.totalCode = this.tableData.length
					} else {
						this.tableData = []
						this.codeNum = ''
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//新建抄读项
			addClick() {
				this.getList();
				this.show = true
				window.sessionStorage.setItem('childrenId', '')
			},
			//第一层新增+1
			addCreate() {
				if(this.tableData.length == 0) {
					open = true;
				}
				this.tableData.forEach((item, index) => {
					if(item.type == 0) {
						if(item.title_code || item.title_code == '0') {
							open = true;
						} else {
							open = false;
							this.$message('请输入抄读项！')
						}
					} else {
						open = true;
					}
				})
				if(open == true) {
					this.tableData.push({
						type: 0, //配置类型
						title_code: '', //抄读项
						start_idx: '', //起始字节
						end_idx: '', //结束字节
						sort_type: false, //倒叙复选框
						data_type: '', //数据类型
						unit_name: '', //单位
						precision_str: '', //数据精度
						isevent: false, //事件复选框
						isa: false, //电流复选框
						isv: false, //电压复选框
						childs: [], //子级
						sign: this.$uuid.v1()
					})
					this.codeNum = this.tableData.length
				}
			},
			//第一层删除
			deleteClickQ(index, id) {
				this.tableData.forEach((item, i) => {
					if(i == index) {
						if(item.id) { //接口删除
							let config = headers.headers('save')
							var pass_token = config.pass_token
							var timestamp = config.timestamp
							var params = {
								id: id,
								status: 0
							}
							//console.log(params)
							this.$confirm('确认要删除吗?', '注意', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
							}).then(() => {
								axios.post(this.http + '/zkep2/parser_detail/save', qs.stringify(params), {
									headers: {
										'pass-token': pass_token,
										'time': timestamp
									}
								}).then(res => {
									//console.log(res)
									if(res.data.id) {
										this.getList();
										this.$message({
											type: 'success',
											message: '删除成功!'
										});
									} else {
										this.$message({
											type: 'error',
											message: '删除失败!'
										});
									}
								}).catch(err => {
									console.log(err)
								})

							}).catch(() => {
								this.$message({
									type: 'info',
									message: '已取消删除'
								});
							});
						} else { //前端删除
							this.tableData.splice(index, 1);
						}
					}
				})
				this.codeNum = this.tableData.length
			},
			//第二层生成
			createClick2(index, num, row) {
				this.tableData.forEach((item, i) => {
					if(item.type == 1) {
						if(i == index) {
							for(var i = 0; i < num; i++) {
								item.childs.push({
									child_code: '', //子抄读项
									child_start: '', //子起始字节
									child_end: '', //子结束字节
									child_unit: '', //子单位
									child_precision: '', //子数据精度
									child_isevent: false, //子事件复选框
									child_isa: false, //子电流复选框
									child_isv: false, //子电压复选框
									child_isenum: '0',
									sign: this.$uuid.v1()
								})
							}
							item.childs.forEach((item_z, i_z) => {
								item.buttonDisabled = true
							})
						}
					}
				})
				this.$refs.tableRef.toggleRowExpansion(row);
			},
			//第二层新增+1
			addCreate2(index) {
				this.tableData.forEach((item, i) => {
					if(item.type == 1) {
						if(i == index) {
							item.childs.push({
								child_code: '', //子抄读项
								child_start: '', //子起始字节
								child_end: '', //子结束字节
								child_unit: '', //子单位
								child_precision: '', //子数据精度
								child_isevent: false, //子事件复选框
								child_isa: false, //子电流复选框
								child_isv: false, //子电压复选框
								child_isenum: '0',
								sign: this.$uuid.v1()
							})
						}
						item.childs.forEach((item_z, i_z) => {
							item.codeNum2 = item.childs.length
						})
					}
				})
			},
			//第二层删除
			deleteClickS(index) {
				this.childrenId = ''
				window.sessionStorage.setItem('childrenId', index)
			},
			//第二层表格的点击（删除）
			expandChange(parentIndex) {
				this.parentIndex = parentIndex
				this.childrenId = window.sessionStorage.getItem('childrenId')
				if(this.childrenId) {
					this.tableData.forEach((item, i) => {
						if(item.type == 1) {
							if(i == this.parentIndex) {
								item.childs.forEach((item_z, i_z) => {
									if(i_z == this.childrenId) {
										if(item_z.parent_id) { //接口删除
											let config = headers.headers('save')
											var pass_token = config.pass_token
											var timestamp = config.timestamp
											var params = {
												id: item_z.child_id,
												parent_id: item_z.parent_id,
												status: 0
											}
											//console.log(params)
											this.$confirm('确认要删除吗?', '注意', {
												confirmButtonText: '确定',
												cancelButtonText: '取消',
											}).then(() => {
												axios.post(this.http + '/zkep2/parser_detail/save', qs.stringify(params), {
													headers: {
														'pass-token': pass_token,
														'time': timestamp
													}
												}).then(res => {
													//console.log(res)
													if(res.data.id) {
														this.getList();
														window.sessionStorage.setItem('childrenId', '')
														this.$message({
															type: 'success',
															message: '删除成功!'
														});
													} else {
														this.$message({
															type: 'error',
															message: '删除失败!'
														});
													}
												}).catch(err => {
													console.log(err)
												})

											}).catch(() => {
												window.sessionStorage.setItem('childrenId', '')
												this.$message({
													type: 'info',
													message: '已取消删除'
												});
											});
										} else { //前端删除
											item.childs.splice(this.childrenId, 1);
											window.sessionStorage.setItem('childrenId', '')
										}
										item.codeNum2 = item.childs.length
									}
								})
							}
						}
					})
				}
			},
			/*
			 * 第三层
			 * */
			//起始字节、结束字节改变&&值的含义为是
			start_idxChange(val, index, row) {
				if(val == 1) { //先删除，再添加
					this.tableData.forEach((item, index_z) => {
						if(index_z == this.parentIndex) {
							item.childs.forEach((item_s, index_s) => {
								if(index == index_s) {
									for(var i = 0; i < item_s.childs.length; i++) {
										let config = headers.headers('save')
										var pass_token = config.pass_token
										var timestamp = config.timestamp
										if(item_s.childs[i].enum_id) {
											var params = {
												id: item_s.childs[i].enum_id,
												status: 0
											}
											axios.post(this.http + '/zkep2/parser_enum/save', qs.stringify(params), {
												headers: {
													'pass-token': pass_token,
													'time': timestamp
												}
											}).then(res => {
												//console.log(res)
												if(res.data.id) {
													//this.getList();
													//this.$message({
													//type: 'success',
													//message: '删除成功!'
													//});
												} else {
													//this.$message({
													//type: 'error',
													//message: '删除失败!'
													//});
												}
											}).catch(err => {
												console.log(err)
											})
										}
									}
									item_s.childs = []
								}
							})
						}
					})
					this.radioChange(val, index, row)
					this.$refs.tableRef3.toggleRowExpansion(row);
				}
			},
			//单选框改变
			radioChange(val, index, row) {
				if(row.child_end >= 0 && row.child_start >= 0) {
					var byteNum = row.child_end - row.child_start + 1 //字节
					var binary = '' //二进制数
					for(var i = 0; i < byteNum; i++) {
						binary = binary + '1'
					}
					/*二进制转十进制*/
					var decimalism; //十进制数
					decimalism = parseInt(binary, 2)
					if(val == 0) { //否 删除所有
						this.tableData.forEach((item, index_z) => {
							if(index_z == this.parentIndex) {
								item.childs.forEach((item_s, index_s) => {
									if(index == index_s) {
										for(var i = 0; i < item_s.childs.length; i++) {
											let config = headers.headers('save')
											var pass_token = config.pass_token
											var timestamp = config.timestamp
											if(item_s.childs[i].enum_id) {
												var params = {
													id: item_s.childs[i].enum_id,
													status: 0
												}
												//console.log(params)
												axios.post(this.http + '/zkep2/parser_enum/save', qs.stringify(params), {
													headers: {
														'pass-token': pass_token,
														'time': timestamp
													}
												}).then(res => {
													//console.log(res)
													if(res.data.id) {
														//this.getList();
														//this.$message({
														//type: 'success',
														//message: '删除成功!'
														//});
													} else {
														//this.$message({
														//type: 'error',
														//message: '删除失败!'
														//});
													}
												}).catch(err => {
													console.log(err)
												})
											}
										}
										item_s.childs = []
									}
								})
							}
						})
					} else if(val == 1) { //是 增加
						this.tableData.forEach((item, index_z) => {
							if(index_z == this.parentIndex) {
								item.childs.forEach((item_s, index_s) => {
									if(index == index_s) {
										var arr = []
										for(var i = 0; i <= decimalism; i++) {
											arr.push({
												enum_val: i,
												enum_name: '',
												enum_isevent: false,
												enum_oad: '',
											})
											item_s.childs = arr
										}
									}
								})
							}
						})
					}
					this.$refs.tableRef3.toggleRowExpansion(row);
				}
			},
			//抄读项的改变
			specilChange(val, index) {
				this.tableData.forEach((item, index_s) => {
					if(index != index_s) {
						if(item.title_code && item.title_code == val) {
							this.$message({
								type: 'info',
								message: '抄读项重复，请重新选择抄读项!'
							});
						}
					}
				})
			},
			//编辑数据标识的改变
			codeValueChange() {
				var params = {
					parser_id: this.parser_id,
					code: this.codeValue
				}
				let config = headers.headers('getByParserAndCode')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser_item/getByParserAndCode', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.id) {
						if(this.codeValue != this.codeValue2) {
							this.$message({
								type: 'info',
								message: '数据标识已存在，请重新输入数据标识!'
							});
							this.codeValue = ''
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//确认保存
			save() {
				//console.log(this.tableData)
				var total;
				if(this.codeNum >= 20) {
					total = this.total - 20 + this.codeNum
				} else {
					total = this.total + this.codeNum - this.totalCode
				}
				/*parser_item的保存*/
				var timestamp = Date.parse(new Date());
				var manager_id = window.sessionStorage.getItem('id')
				var params = {
					id: this.parser_item_id,
					parser_id: this.parser_id,
					name: this.childValue,
					code: this.codeValue,
					//total: this.codeNum,
					total: total,
					manager_id: manager_id,
					create_time: timestamp,
					isevent: 0,
					status: 1,
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(this.codeValue && this.codeNum) {
					axios.post(this.http + '/zkep2/parser_item/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.parser_itemId = res.data.id
							this.saveZ();
						} else {
							this.$message('新增失败！')
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.$message('请输入必填项！')
				}
			},
			//数据处理
			dataHandle() {
				this.tableData.forEach(item => {
					if(!item.sort_type) {
						item.sort_type = 0
					} else {
						item.sort_type = 1
					}
					if(!item.isevent) {
						item.isevent = 0
					} else {
						item.isevent = 1
					}
					if(!item.isa) {
						item.isa = 0
					} else {
						item.isa = 1
					}
					if(!item.isv) {
						item.isv = 0
					} else {
						item.isv = 1
					}
					if(item.childs.length > 0) {
						item.childs.forEach((item_z, i_z) => {
							if(!item_z.child_isevent) {
								item_z.child_isevent = 0
							} else {
								item_z.child_isevent = 1
							}
							if(!item_z.child_isa) {
								item_z.child_isa = 0
							} else {
								item_z.child_isa = 1
							}
							if(!item_z.child_isv) {
								item_z.child_isv = 0
							} else {
								item_z.child_isv = 1
							}
						})
					}
				})
				this.tableData.forEach((item, i) => {
					this.titleData.forEach(items => {
						if(item.title_code == items.title) {
							item.title_code = items.id
						}
						item.childs.forEach(itemc => {
							if(itemc.child_code == items.title) {
								itemc.child_code = items.id
							}
						})
					})
				})
			},
			//常规和位解析保存
			async saveZ() {
				//数据的处理
				this.dataHandle();
				for(var i = 0; i < this.tableData.length; i++) {
					var timestamp = Date.parse(new Date());
					var manager_id = window.sessionStorage.getItem('id')
					let config = headers.headers('save')
					var pass_token = config.pass_token
					var timestamp = config.timestamp
					const res2 = await axios.post(this.http + '/zkep2/parser_detail/save',
						qs.stringify({
							id: this.tableData[i].id,
							parser_id: this.parser_id, //所属抄读
							parser_item_id: this.parser_itemId, //所属抄读项id
							type: this.tableData[i].type, //类型
							parent_id: 0,
							title_code: this.tableData[i].title_code, //名称标识
							start_idx: this.tableData[i].start_idx, //开始字节
							end_idx: this.tableData[i].end_idx, //结束字节
							sort_type: this.tableData[i].sort_type, //是否倒序
							data_type: this.tableData[i].data_type, //数据类型
							unit_name: this.tableData[i].unit_name, //单位
							precision_str: this.tableData[i].precision_str, //精度
							isevent: this.tableData[i].isevent, //是否事件
							isa: this.tableData[i].isa, //是否乘电流倍比
							isv: this.tableData[i].isv, //是否乘电压倍比
							isenum: 0,
							status: 1,
							manager_id: manager_id,
							create_time: timestamp,
						}), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(async res => {
						this.show = false
						this.getParser_item();
						this.dataHandle();
						if(!this.tableData[i].childs) {
							this.getList();
							this.getParser_item();
						}
						if(res.data.id) {
							if(res.data.type == 1) {
								if(this.tableData[i].childs && this.tableData[i].childs.length > 0) {
									for(var j = 0; j < this.tableData[i].childs.length; j++) {
										var isenum;
										if(this.tableData[i].childs[j].child_isenum == '0') {
											isenum = 0
										} else if(this.tableData[i].childs[j].child_isenum == '1') {
											isenum = 1
										}
										var timestamp = Date.parse(new Date());
										var manager_id = window.sessionStorage.getItem('id')
										let config = headers.headers('save')
										var pass_token = config.pass_token
										var timestamp = config.timestamp
										const res3 = await axios.post(this.http + '/zkep2/parser_detail/save',
											qs.stringify({
												id: this.tableData[i].childs[j].child_id,
												parser_id: this.parser_id, //所属抄读
												parser_item_id: this.parser_itemId, //所属抄读项id
												type: 1, //类型
												parent_id: res.data.id,
												title_code: this.tableData[i].childs[j].child_code, //名称标识
												start_idx: this.tableData[i].childs[j].child_start, //开始字节
												end_idx: this.tableData[i].childs[j].child_end, //结束字节
												sort_type: 0, //是否倒序
												data_type: '', //数据类型
												unit_name: this.tableData[i].childs[j].child_unit, //单位
												precision_str: this.tableData[i].childs[j].child_precision, //精度
												isevent: this.tableData[i].childs[j].child_isevent, //是否事件
												isa: this.tableData[i].childs[j].child_isa, //是否乘电流倍比
												isv: this.tableData[i].childs[j].child_isv, //是否乘电压倍比
												isenum: isenum,
												status: 1,
												manager_id: manager_id,
												create_time: timestamp,
											}), {
												headers: {
													'pass-token': pass_token,
													'time': timestamp
												}
											}).then(res => {
											//console.log(res)
											if(res.data.id) {
												this.show = false
												if(!this.tableData[i].childs[j].childs) {
													this.getList();
													this.getParser_item();
												}
												var timestamp = Date.parse(new Date());
												var manager_id = window.sessionStorage.getItem('id')
												let config = headers.headers('save')
												var pass_token = config.pass_token
												var timestamp = config.timestamp
												if(this.tableData[i].childs[j].childs && this.tableData[i].childs[j].childs.length > 0) {
													for(var k = 0; k < this.tableData[i].childs[j].childs.length; k++) {
														if(this.tableData[i].childs[j].child_isevent == 0) {
															this.tableData[i].childs[j].childs[k].enum_isevent = false
															this.tableData[i].childs[j].childs[k].enum_oad = ''
														}
														var enum_isevent;
														if(this.tableData[i].childs[j].childs[k].enum_isevent == true) {
															enum_isevent = 1
														} else {
															enum_isevent = 0
														}
														var enum_oad;
														enum_oad = this.tableData[i].childs[j].childs[k].enum_oad.replace(/，/ig, ',');
														axios.post(this.http + '/zkep2/parser_enum/save',
															qs.stringify({
																id: this.tableData[i].childs[j].childs[k].enum_id,
																parser_detail_id: res.data.id,
																val: this.tableData[i].childs[j].childs[k].enum_val,
																name: this.tableData[i].childs[j].childs[k].enum_name,
																isevent: enum_isevent,
																oad: enum_oad,
																status: 1,
																manager_id: manager_id,
																create_time: timestamp,
															}), {
																headers: {
																	'pass-token': pass_token,
																	'time': timestamp
																}
															}).then(res => {
															//console.log(res)
															if(res.data.id) {
																this.getParser_item()
																this.show = false
																if(!this.tableData[i]) {
																	this.getList()
																}

															} else {
																this.$message('操作失败！')
															}
														}).catch(err => {
															console.log(err)
														})
														//														//this.cancleClick()
													}
												}
											} else {
												this.$message('操作失败！')
											}
										}).catch(err => {
											console.log(err)
										})
									}
								} else {
									//this.cancleClick()
								}
							}
						} else {
							this.$message('操作失败！')
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//取消
			cancleClick() {
				this.getList()
				this.show = false
				this.codeNum = ''
				//this.codeValue = ''
				this.parser_itemId = ''
			},
			//控制按钮的展示
			getRowClass(row, rowIndex) {
				let data = row.row;
				let res = [];
				if(data.childs && data.childs.length > 0) {
					res.push('row-expand-has')
					return res;
				} else {
					res.push('row-expand-unhas')
					return res;
				}
			},
			//返回
			backClick() {
				this.$router.push({
					path: '/parser/parserDetail',
					name: 'ParserDetail',
					query: {
						id: this.parser_id,
						sI: this.secondPageIndex,
						fI: this.firstPageIndex
					}
				})
			},
			mouseOver(parent_index) {
				this.parent_index = parent_index
			},
			//第一层第三级的点击
			clickUnitTreeNode(data) {
				if(data.parent_id == undefined) {
					this.tableData.forEach((item, i) => {
						this.titleData.forEach(items => {
							if(this.row_index == i) {
								if(data.title == items.title) {
									item.title_code = items.title
									setTimeout(() => {
										this.$refs.elSelectTable.blur()
									}, 200) // 收起下拉列表
								}
							}
						})
					})
				}
			},
			//第二层第三级的点击
			clickUnitTreeNodeChild(data) {
				if(data.parent_id == undefined) {
					this.tableData.forEach((item, i) => {
						if(i == this.parent_index) {
							item.childs.forEach((item_c, i_c) => {
								this.titleData.forEach(items => {
									if(this.row_index == i_c) {
										if(data.title == items.title) {
											item_c.child_code = items.title
											this.$refs.elSelectTable.blur() // 收起下拉列表
										}
									}
								})
							})
						}

					})
				}
			},
			rowClick(val) {
				this.row_index = val
			},
			//第一级列表
			async treeList(resolve) {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					parent_id: 0
				} //console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				const res = await axios.get(this.http + '/zkep2/title_category/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					return resolve(res.data);
				}).catch(err => {
					console.log(err)
				})
			},
			//第二级列表
			async loadchildnode(node, resolve) {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					parent_id: node.data.id
				} //console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				const res2 = await axios.get(this.http + '/zkep2/title_category/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					return resolve(res.data);
				}).catch(err => {
					console.log(err)
				})
			},
			//第三级列表
			async getLowerList(node, resolve) {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					title_category_id: node.data.id
				} //console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				const res2 = await axios.get(this.http + '/zkep2/title_link/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					return resolve(res.data);
				}).catch(err => {
					console.log(err)
				})
			},
			//加载
			load(node, resolve) {
				/*懒加载缓存刷新处理*/
				if(node.level === 0) {
					this.treeList(resolve);
				}
				if(node.level == 1) {
					this.loadchildnode(node, resolve);
				}
				if(node.level == 2) {
					this.getLowerList(node, resolve);
				}
			},
		}
	}
</script>

<style>
	.parserChildrenDetail {
		height: 100%;
		padding: 3.2% 12% 0 12%;
		position: relative;
	}
	
	.parserChildrenDetail .backClass {
		padding: 8px 22px;
		font-size: 13px;
		margin-bottom: 24px;
	}
	
	.parserChildrenDetail .el-table th {
		color: #000;
	}
	
	.parserChildrenDetail .el-table {
		font-size: 12px;
	}
	
	.parserChildrenDetail .el-table th,
	.parserChildrenDetail .el-table td,
	.parserChildrenDetail .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.parserChildrenDetail .el-table th {
		padding: 10px 0!important;
		font-weight: 400;
		text-align: left;
		color: #999;
	}
	
	.parserChildrenDetail .headerBox {
		position: relative;
		height: 30px;
		line-height: 30px;
		padding: 6px 30px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
		font-size: 13px;
		margin-bottom: 10px;
		margin-top: 10px;
	}
	
	.parserChildrenDetail .addButtonClass {
		position: absolute;
		top: 4px;
		right: 1%;
		padding: 10px 12px;
		font-size: 13px;
	}
	
	.parserChildrenDetail .tableBox {
		padding: 0 20px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
	}
	
	.parserChildrenDetail .editClass {
		color: #439DFD;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.parserChildrenDetail .el-dialog__header {
		margin-bottom: 20px;
	}
	
	.parserChildrenDetail .el-dialog__title {
		color: #999;
	}
	
	.parserChildrenDetail .el-dialog__footer {
		text-align: center;
	}
	
	.parserChildrenDetail .pagination {
		text-align: center;
	}
	
	.parserChildrenDetail .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
	
	.parserChildrenDetail .el-dialog {
		border-radius: 0;
	}
	/*遮罩层*/
	
	.parserChildrenDetail .popContainer {
		font-size: 13px;
		z-index: 2;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		padding-top: 8%!important;
		padding-bottom: 8%!important;
		overflow: auto;
	}
	
	.parserChildrenDetail .headerTop {
		position: relative;
		width: 100%;
		height: 50px;
		line-height: 50px;
		margin-bottom: 1%;
		background-color: #fff!important;
	}
	
	.parserChildrenDetail .inputClass {
		text-indent: 10px;
		outline: none;
		padding: 6px 0;
		border: 1px solid #ccc;
		width: 20%;
	}
	
	.parserChildrenDetail .rightBox {
		position: absolute;
		top: 0;
		right: 16%;
	}
	
	.parserChildrenDetail .inputClass2 {
		outline: none;
		padding: 6px 0;
		border: 1px solid #ccc;
		text-indent: 10px;
	}
	
	.parserChildrenDetail .clickButtonClass {
		border-radius: 0;
		padding: 7px 16px;
		margin-left: -4px;
	}
	
	.parserChildrenDetail .buttomBox {
		position: absolute;
		top: 0;
		right: 10px;
	}
	
	.parserChildrenDetail .confrim,
	.parserChildrenDetail .cancle {
		padding: 10px 26px;
	}
	
	.parserChildrenDetail .content {
		width: 100%;
		background-color: #fff!important;
	}
	/*复选框*/
	
	.parserChildrenDetail .checkBoxClass {
		display: inline-block;
		width: 18px;
		margin-right: 40px;
		height: 18px;
		line-height: 10px;
		padding: 2px 1px;
		background-color: #0079DD;
		text-align: center;
		vertical-align: top;
	}
	
	.parserChildrenDetail .el-checkbox__inner {
		border: 1px solid #fff!important;
		background-color: #0079DD;
		border-radius: 0!important;
	}
	
	.parserChildrenDetail .el-input__icon {
		line-height: 0;
	}
	
	.parserChildrenDetail .el-checkbox__input.is-checked .el-checkbox__inner,
	.parserChildrenDetail .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #0079DD;
		border-color: #0079DD!important;
	}
	
	.parserChildrenDetail .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #000;
		font-size: 12px;
	}
	
	.parserChildrenDetail .el-checkbox__label {
		vertical-align: top;
		font-size: 12px;
	}
	
	.parserChildrenDetail .inputClass3 {
		width: 100px;
		text-indent: 10px;
		outline: none;
		padding: 6px 0;
		border: 1px solid #ccc;
	}
	
	.parserChildrenDetail .clickButtonClass2 {
		vertical-align: top;
		border-radius: 0;
		padding: 7px 6px;
		margin-left: -4px;
	}
	
	.parserChildrenDetail .content .el-input__inner {
		height: 30px;
		line-height: 30px;
		border-radius: 0;
		padding: 0px;
		text-align: center;
	}
	
	.parserChildrenDetail .content select {
		height: 30px;
		line-height: 30px;
		border: 1px solid #ccc;
		outline: none;
		border-radius: 5px;
		color: #999;
	}
	
	.parserChildrenDetail .childTable .el-table th {
		/*display: none;*/
	}
	
	.parserChildrenDetail .childTable2 .el-table th {
		display: none;
	}
	
	.parserChildrenDetail .el-table .cell {
		padding-right: 2px;
	}
	
	.parserChildrenDetail .addButtonClassF {
		margin: 6px 0 6px 95%;
	}
	/*控制折叠按钮的展示*/
	
	.row-expand-unhas .el-table__expand-column {
		pointer-events: none;
	}
	
	.row-expand-unhas .el-table__expand-column .el-icon {
		visibility: hidden;
	}
	/*select-tree样式*/
	
	.parserChildrenDetail .el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
		height: auto;
		max-height: 274px;
		padding: 0;
		overflow: hidden;
		overflow-y: auto;
	}
	
	.parserChildrenDetail .el-select .el-input__inner {
		border-radius: 4px!important;
		border: 1px solid #ccc;
		color: #999;
		text-align: left;
		text-indent: 6px;
	}
	
	.parserChildrenDetail .is-leaf::before {
		opacity: 0;
	}
	/*媒体查询*/
	
	@media screen and (max-width: 670px) {
		.parserChildrenDetail .numText {
			display: none;
		}
	}
	
	.select-drop-down-platform {
		width: 200px!important;
	}
	
	select {
		font-size: 13px;
		padding: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/Parser/ParserChildrenDetail.vue